import { useEffect, useRef } from 'react';
import noop from 'lodash/noop';
import type { BulkOpsAnalyticsControllerContext } from '@atlassian/jira-bulk-operations-analytics/src/controllers/types.tsx';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import type { AnalyticsAttributesUntyped } from '@atlassian/jira-product-analytics-bridge/src/types';
import {
	useBulkOperationType,
	useBulkOperationsActions,
} from '@atlassian/jira-bulk-operations-common/src/controllers/use-bulk-operations/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export const useFlagAnalytics = (
	attributes: AnalyticsAttributesUntyped,
	bulkOpsFlow?: BulkOpsAnalyticsControllerContext, // remove completely on clean up of dee-7206-add-bulk-ops-type-to-analytics
) => {
	const analyticsEventFired = useRef(false);
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const bulkOperationType = fg('dee-7206-add-bulk-ops-type-to-analytics')
		? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
			useBulkOperationType()
		: null;
	const { resetState } = fg('dee-7206-add-bulk-ops-type-to-analytics')
		? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
			useBulkOperationsActions()
		: { resetState: noop };

	useEffect(() => {
		if (!analyticsEventFired.current) {
			const analyticsEvent = createAnalyticsEvent({
				actionSubject: 'bulkProcess',
				action: 'complete',
			});

			const actionSubjectId = fg('dee-7206-add-bulk-ops-type-to-analytics')
				? undefined
				: bulkOpsFlow?.bulkOperationType;

			const analyticsAttributes = {
				...attributes,
				...(fg('dee-7206-add-bulk-ops-type-to-analytics')
					? {
							bulkOperationType: bulkOperationType?.type,
						}
					: { bulkOpsSessionID: bulkOpsFlow?.sessionID }),
			};
			if (actionSubjectId && !fg('dee-7206-add-bulk-ops-type-to-analytics')) {
				fireUIAnalytics(analyticsEvent, actionSubjectId, analyticsAttributes);
			} else {
				fireUIAnalytics(analyticsEvent, analyticsAttributes);
			}
			if (fg('dee-7206-add-bulk-ops-type-to-analytics')) {
				resetState();
			} else {
				bulkOpsFlow?.setBulkOperationType(undefined);
			}
			analyticsEventFired.current = true;
		}
	}, [createAnalyticsEvent, bulkOpsFlow, attributes, bulkOperationType?.type, resetState]);
};
